import { makeStyles } from "@cirrus/ui-kit";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const useStyles = makeStyles({
  search: {
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "0",
    borderBottom: `2px solid ${DefaultColors.white}`,
    color: "white",
    fontSize: "11px",
    lineHeight: "25px",
    paddingLeft: "3px",
    position: "relative",
    marginRight: "10px",
    top: "-6px",
    height: "25px",
    width: "100px",
    zIndex: "1"
  },
  icon: {
    fontSize: "22px",
    color: DefaultColors.white,
    paddingRight: "7px",

    "&:hover": {
      cursor: "pointer"
    }
  },
  hidden: {
    display: "none !important"
  }
})
